import { render, staticRenderFns } from "./KcsXHRatingForm.vue?vue&type=template&id=2241232a&"
import script from "./KcsXHRatingForm.vue?vue&type=script&lang=js&"
export * from "./KcsXHRatingForm.vue?vue&type=script&lang=js&"
import style0 from "./KcsXHRatingForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports